export default __webpack_public_path__ + "static/media/maid.e5dbdb65.png";